import Choices from 'choices.js';
import countries from '../../vendor/countries';

export default (form) => {
    const stateDropdownFields = Array.from(form.querySelectorAll('.stateCustomDropdown-field'));
    const countryDropdownFields = Array.from(form.querySelectorAll('.countryCustomDropdown-field'));
    const selects = Array.from(form.querySelectorAll('.dropdown select, .emaildropdown select, .phone select, .wForm select'));

    // State select
    stateDropdownFields.forEach((stateField) => {
        const selected = stateField.querySelector('select').dataset.selected;
        const stateSelect = new Choices(stateField.querySelector('select'), {
            searchEnabled: false,
            itemSelectText: '',
            choices: [
                {
                    value: 'ACT',
                    label: 'Australian Capital Territory',
                    selected: selected === 'ACT'
                    || selected === 'Australian Capital Territory',
                },
                {
                    value: 'NSW',
                    label: 'New South Wales',
                    selected: selected === 'NSW'
                        || selected === 'New South Wales',
                },
                {
                    value: 'NT',
                    label: 'Northern Territory',
                    selected: selected === 'NT'
                        || selected === 'Northern Territory',
                },
                {
                    value: 'QLD',
                    label: 'Queensland',
                    selected: selected === 'QLD'
                        || selected === 'Queensland',
                },
                {
                    value: 'SA',
                    label: 'South Australia',
                    selected: selected === 'SA'
                        || selected === 'South Australia',
                },
                {
                    value: 'TAS',
                    label: 'Tasmania',
                    selected: selected === 'TAS'
                        || selected === 'Tasmania',
                },
                {
                    value: 'VIC',
                    label: 'Victoria',
                    selected: selected === 'VIC'
                        || selected === 'Victoria',
                },
                {
                    value: 'WA',
                    label: 'Western Australia',
                    selected: selected === 'WA'
                        || selected === 'Western Australia',
                },
            ],
        });

        stateField.addEventListener('update-choice', (e) => {
            stateSelect.setChoiceByValue(e.detail);
        });
    });

    countryDropdownFields.forEach((countryField) => {
        const countrySelect = new Choices(countryField.querySelector('select'), {
            placeholder: false,
            itemSelectText: '',
            choices: [...countries],
        });

        countryField.addEventListener('update-choice', (e) => {
            countrySelect.setChoiceByValue(e.detail);
        });

        const selected = countryField.dataset.selected;
        countrySelect.setChoiceByValue(selected);

        // Hide/Show state field
        let linkedStateField = document.querySelector(`#${countryField.dataset.linkedStateField}`);
        if (!linkedStateField) {
            linkedStateField = countryField.nextElementSibling.classList.contains('stateCustomDropdown-field') ? countryField.nextElementSibling : linkedStateField;
            linkedStateField = countryField.previousElementSibling.classList.contains('stateCustomDropdown-field') ? countryField.nextElementSibling : linkedStateField;
        }

        countryField.addEventListener('addItem', (event) => {
            if (linkedStateField) {
                if (event.detail.value === 'Australia' || event.detail.value === '') {
                    linkedStateField.style.display = 'block';
                } else {
                    linkedStateField.style.display = 'none';
                }
            }
        }, false);
    });

    selects.forEach((select) => {
        if (!Array.from(select.classList).includes('js-disable-choices')) {
            new Choices(select, {
                searchEnabled: false,
                itemSelectText: '',
            });
        }
    });
};
